module.exports = __webpack_public_path__ + "img/Bpoint2.0b4e139d.png";